export const consultantHistoryArticle = {
  title: 'AI Business Consultant: Conversation History',
  slug: 'consultant-history',
  content: `AI Business Consultant: Conversation History

Use History to resume prior conversations.

1) Review past chats
- Open the History tab to see saved conversations.
- Each card shows a preview of the first user message.

2) Reopen a chat
- Click a chat card or the “Open” button to resume.
- You’ll be taken back to the Chat tab with the conversation loaded.

3) Start fresh
- Use “Start New Chat” if you want a clean thread.
`,
};
